import { z } from "zod";

const DeleteAuditRegistrySchema = z
  .object({
    id: z.string().uuid({ message: "Id is required." }),
  })
  .strict();

export default DeleteAuditRegistrySchema;
